import React from 'react';
import 'css/ball-beat.css';

import styled from 'styled-components';

const LoadingWrapper = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
`;

const BallLoader = () => {
  return (
    <LoadingWrapper>
      <div className="la-ball-beat">
        <div />
        <div />
        <div />
      </div>
    </LoadingWrapper>
  );
};

export default BallLoader;
